import {
  PartsModalTablerow,
  PartsPaginationLink,
} from "components/noticepage_components/utils"
import React, { useState } from "react"

export const PartsModal = ({
  Parts,
  TitelOnline,
  clicked_disabled_tab,
  get_remote_data,
  parts_modal_open,
  picked_part,
  reset,
  set_parts_modal_open,
  set_picked_part,
  set_clicked_disabled_tab,
  set_current_ref,
  set_current_tab,
  tab_ref_correlation,
}) => {
  const closeModal = () => {
    set_parts_modal_open("")
  }
  const closeModalAndReset = () => {
    reset()
    set_parts_modal_open("")
    setPreselectedPartID("none")
  }

  const [preselectedPartID, setPreselectedPartID] = useState("none")
  const [skip_parts, set_skip_parts] = useState(0)
  const pick_part = () => {
    get_remote_data(preselectedPartID)
    set_picked_part(Parts.find(({ Id }) => Id === preselectedPartID))
    if (!!clicked_disabled_tab) {
      set_current_tab(tab_ref_correlation[clicked_disabled_tab].tab)
      set_current_ref(tab_ref_correlation[clicked_disabled_tab].ref)
    }
    closeModal()
    set_clicked_disabled_tab(false)
  }

  Parts = Parts.sort((a, b) => a.Number - b.Number)
  const num_active_parts = 10
  const acitve_parts = Parts.slice(
    num_active_parts * skip_parts,
    num_active_parts * skip_parts + num_active_parts
  )

  return (
    <div className={`modal ${parts_modal_open}`}>
      <div
        className="modal-background"
        onClick={closeModal}
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
        aria-label="Close Success Modal"
      ></div>
      <div className="modal-content" style={{ overflow: "hidden" }}>
        <div
          className="box is-flex is-flex-direction-column"
          style={{ maxWidth: 800, margin: "0 auto" }}
        >
          <p className="title is-5 mb-2 has-text-mitternachtsblau">
            Lose für {TitelOnline}
          </p>
          <hr className="is-mitternachtsblau-30 my-3" />

          <table className="table is-fulllwidth is-striped has-text-mitternachtsblau">
            <tbody>
              {acitve_parts?.map((active_part, i) => {
                return (
                  <PartsModalTablerow
                    key={`modalpart-tablerow-${i}`}
                    {...{
                      active_part,
                      i,
                      preselectedPartID,
                      setPreselectedPartID,
                    }}
                  />
                )
              })}
            </tbody>
          </table>
          {Parts.length > num_active_parts ? (
            <nav
              className="pagination is-centered is-small mx-auto my-0 mt-auto"
              style={{ maxWidth: "50%" }}
              role="navigation"
              aria-label="pagination"
            >
              <ul className="pagination-list">
                {Array.from({
                  length: Math.max(
                    Math.ceil(Parts.length / num_active_parts),
                    1
                  ),
                })?.map((_, index) => {
                  return (
                    <PartsPaginationLink
                      key={"parts-pagination-" + index}
                      {...{ index, skip_parts, set_skip_parts }}
                    />
                  )
                })}
              </ul>
            </nav>
          ) : null}
          <div className="mt-4">
            <div className="buttons">
              {picked_part !== "none" ? (
                <button
                  onClick={closeModalAndReset}
                  className="button is-tertiary mr-auto"
                >
                  <b>Zur Übersicht</b>
                </button>
              ) : null}
              <button
                className="button is-tertiary ml-auto"
                aria-label="delete"
                onClick={closeModal}
              >
                <b>Abbrechen</b>
              </button>
              <button
                disabled={preselectedPartID === "none"}
                onClick={pick_part}
                className="button is-sonnengelb"
              >
                <b>Auswählen</b>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
